"use client";

import { c as _c } from "react/compiler-runtime";
import { Spinner } from "@/components/dotLoader/DotLoader";
import { useAuth } from "@/components/auth/Auth";
import { useProfileWaveMutation } from "@/hooks/useProfileWaveMutation";
import type { ApiWave } from "@/generated/models/ApiWave";
import { areSameProfileIdentity } from "@/helpers/ProfileHelpers";
import { isPublicNonDirectMessageWave } from "@/helpers/waves/wave.helpers";
import { useCallback } from "react";
export default function WaveProfileWaveAction(t0) {
  const $ = _c(16);
  const {
    wave,
    onSuccess
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useAuth();
  const {
    updateProfileWave,
    clearSelectedProfileWave,
    isPending
  } = useProfileWaveMutation(connectedProfile);
  const isSelectedProfileWave = connectedProfile?.profile_wave_id === wave.id;
  const canManageProfileWave = Boolean(connectedProfile) && !activeProfileProxy && areSameProfileIdentity({
    left: connectedProfile ? {
      id: connectedProfile.id,
      handle: connectedProfile.handle,
      primary_address: connectedProfile.primary_wallet
    } : null,
    right: wave.author
  }) && isPublicNonDirectMessageWave(wave);
  let t1;
  if ($[0] !== clearSelectedProfileWave || $[1] !== isPending || $[2] !== isSelectedProfileWave || $[3] !== onSuccess || $[4] !== updateProfileWave || $[5] !== wave.id) {
    t1 = async () => {
      if (isPending) {
        return;
      }
      const updatedProfile = isSelectedProfileWave ? await clearSelectedProfileWave() : await updateProfileWave(wave.id);
      if (updatedProfile) {
        onSuccess?.();
      }
    };
    $[0] = clearSelectedProfileWave;
    $[1] = isPending;
    $[2] = isSelectedProfileWave;
    $[3] = onSuccess;
    $[4] = updateProfileWave;
    $[5] = wave.id;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleClick = t1;
  let t2;
  bb0: {
    if (isPending) {
      t2 = isSelectedProfileWave ? "Clearing wave" : "Saving wave";
      break bb0;
    }
    t2 = isSelectedProfileWave ? "Clear profile wave" : "Set as profile wave";
  }
  const buttonLabel = t2;
  if (!canManageProfileWave) {
    return null;
  }
  let t3;
  if ($[7] !== handleClick) {
    t3 = async event => {
      event.stopPropagation();
      await handleClick();
    };
    $[7] = handleClick;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isPending) {
    t4 = isPending && <Spinner dimension={14} />;
    $[9] = isPending;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== buttonLabel || $[12] !== isPending || $[13] !== t3 || $[14] !== t4) {
    t5 = <button type="button" disabled={isPending} onClick={t3} className="tw-flex tw-w-full tw-items-center tw-gap-2 tw-border-none tw-bg-transparent tw-px-3 tw-py-1 tw-text-left tw-text-sm tw-leading-6 tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out hover:tw-bg-iron-800" role="menuitem" tabIndex={-1}>{t4}{buttonLabel}</button>;
    $[11] = buttonLabel;
    $[12] = isPending;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}